export default __webpack_public_path__ + "static/media/photo2.07b8acd5.jpg";